<script>
import tinyEditor from "@/components/editors/tiny-editor.vue";

export default {
    props: {
        value: Object,
        v: Object,
        submitted: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        }
    },
    components: {        
        tinyEditor
    },
    methods: {
        
    },
};
</script>

<template>
    <div class="row">
        <div class="form-group col-12">
            <tinyEditor v-model="value.full_description" :validator="v.promotion.full_description" :submitted="submitted"></tinyEditor>
        </div>
    </div> 
</template>